<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.42245 0L2.0677 1.926L0.0414551 9.32162L2.57628 11.9242L0 14.4838L1.90744 21.9121L9.22983 23.9581L11.8061 21.398L14.3409 24L21.6952 22.074L23.7214 14.6774L21.1871 12.0758L23.7629 9.51616L21.8559 2.08787L14.5325 0.0418697L11.9573 2.60154L9.42245 0ZM4.90889 3.34855L8.78292 2.33347L10.477 4.07259L8.0064 6.52758L4.90889 3.34855ZM13.4133 4.09608L15.1347 2.38555L18.992 3.46344L15.8439 6.59141L13.4133 4.09608ZM2.36244 8.71451L3.42965 4.8191L6.52615 7.99813L4.05603 10.4531L2.36244 8.71451ZM17.2999 8.08595L20.448 4.95747L21.452 8.87075L19.7311 10.5813L17.2999 8.08595ZM9.46289 8.02213L11.9335 5.56713L14.3637 8.06246L11.8936 10.5175L9.46289 8.02213ZM5.51252 11.9477L7.98264 9.49267L10.4138 11.988L7.9432 14.443L5.51252 11.9477ZM13.3501 12.012L15.8202 9.55701L18.2509 12.0523L15.7802 14.5073L13.3501 12.012ZM2.31087 15.1292L4.03277 13.4182L6.46295 15.914L3.3159 19.0415L2.31087 15.1292ZM9.39919 15.9375L11.8698 13.4825L14.3005 15.9779L11.8304 18.4329L9.39919 15.9375ZM17.2362 16.0019L19.7069 13.5469L21.401 15.2855L20.3337 19.1809L17.2362 16.0019ZM4.77138 20.5366L7.91894 17.4081L10.3501 19.9034L8.62873 21.6145L4.77138 20.5366ZM13.2864 19.9274L15.7565 17.4724L18.8535 20.6514L14.98 21.666L13.2864 19.9274Z"
    :fill="fill"
  />
</template>

<script setup lang="ts">
defineProps({
  fill: {
    type: String,
    default: "#545464",
  },
});
</script>
